import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { commonModules } from 'src/app/app.config';
import { RequiredRolesDirective } from 'src/app/directives/required-roles.directive';
import { ToolbarAction } from '../../models/toolbar-action';
import { ToolbarService } from '../../services/toolbar.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
  standalone: true,
  imports: [commonModules, RequiredRolesDirective
  ]
})
export class ToolbarComponent {
  toolbarService: ToolbarService = inject(ToolbarService);
  actions$ = this.toolbarService.actions$;
  actions: ToolbarAction[] = [];
  breadcrumbVisible$: Observable<boolean> = this.toolbarService.breadcrumbVisible$;

  constructor() {
    this.actions$.subscribe((actions) => {
     this.actions = actions;
    });
  }

  onClick(action: ToolbarAction) {
    this.toolbarService.actionClicked(action);
  }

}
